export default __webpack_public_path__ + "static/media/noResultsEmployees.91fd94cd.svg";